import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useTranslations } from '@/i18n/TranslationsProvider';
import { usePromotions } from '@/ui/cms';
import { PromotionsPanel } from '@/ui/promotions';

export const Route = createFileRoute('/promotions/')({
  component: PromotionsPage,
});

function PromotionsPage() {
  const { t, i18n } = useTranslation();
  const { selectedLanguage } = useTranslations();
  const isTranslationReady =
    selectedLanguage === 'en' || i18n.hasResourceBundle(selectedLanguage, 'translation');
  const label = (key: string, fallback: string) =>
    isTranslationReady ? t(key, { defaultValue: fallback }) : fallback;

  const { promotions, isLoading, isError, error } = usePromotions();

  return (
    <div className="flex w-full flex-col px-4 pt-4 pb-6 lg:px-20 lg:pt-8 lg:pb-12">
      <PromotionsPanel
        promotions={promotions}
        isLoading={isLoading}
        isError={isError}
        errorMessage={error?.message}
        label={label}
      />
    </div>
  );
}
